module.exports = __webpack_public_path__ + "static/img/sec 02.0c22271.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/sec 02.png
// module id = zca/
// module chunks = 12